module.exports = __webpack_public_path__ + "static/media/icon_event_fast.7016e581.svg";